export const COUNTERPARTY_NAMES: Record<string, string> = {
  marketplace: 'Маркетплейс',
  supplier: 'Поставщик',
  logistics: 'Логистика',
  service: 'Услуги',
};
